export var AcceptedMimeType;
(function (AcceptedMimeType) {
    AcceptedMimeType["JPEG"] = "image/jpeg";
    AcceptedMimeType["PNG"] = "image/png";
    AcceptedMimeType["PDF"] = "application/pdf";
})(AcceptedMimeType || (AcceptedMimeType = {}));
const DocumentInfoRecipe = {
    $type$: 'Recipe',
    name: 'DocumentInfo_1_1_0',
    rule: [
        {
            itemprop: 'document',
            itemtype: { type: 'referenceToBlob' }
        },
        {
            itemprop: 'mimeType',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'documentName',
            itemtype: { type: 'string' }
        }
    ]
};
// Export recipes
const DocumentRecipes = [DocumentInfoRecipe];
export default DocumentRecipes;
//# sourceMappingURL=DocumentRecipes_1_1_0.js.map